<template>
  <v-menu
    offset-y
    :nudge-bottom="12"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        color="primary"
        text
        v-on="on"
        @click.stop
      >
        <v-icon large>
          mdi-menu-open
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <slot />
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'SkudActionsMenu'
}
</script>
